
import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useFranchisesStore = defineStore('franchises', {
  state,
  getters,
  actions
})

export default useFranchisesStore
